/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc */

	/**
	 * PromoLabel
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class PromoLabel
	 * @extends Tc.Module
	 */
	Tc.Module.PromoLabel = Tc.Module.extend({

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;
			// initialize if its a product offer preview promo label.
			if ($ctx.hasClass('productofferpreview')) {
				// resize the h2 if they are too long
				$ctx.find('h2').each(function () {
					if (!$(this).hasClass('smallheader') && $(this).text().length > 5) {
						$(this).addClass('smallheader');
					}
				});
			}

			callback();
		},

		onProductOfferPreviewAnimation: function (data) {
			var $ctx = this.$ctx;

			if (data.activePromoLabel.is($ctx) && !$ctx.data('animation-disabled')) {

				$ctx.addClass('notransition').slideUp(0).delay(data.duration * 1.8).slideDown(data.duration * 0.8, $.proxy(this.enableCssTransitions, this));
			}
		},

		enableCssTransitions: function () {
			this.$ctx.removeClass('notransition');
		}
	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.PromoLabel.js
// module id = 173
// module chunks = 0